export class Configuration {

    public loaderAPIEndpoint: string;
    public analyticsAPIEndpoint: string;
    public automationAPIEndpoint: string;
    public authenticationEndpoint: string;
    public authenticationLoginRedirectUri: string;
    public authenticationLogoutRedirectUri: string;
    public authenticationClientId: string;
    public appInsightsInstrumentationKey: string;
    public identityAPIEndpoint: string;

    constructor(base?: Configuration) {
        if (base != null) {
            this.loaderAPIEndpoint = base.loaderAPIEndpoint
            this.analyticsAPIEndpoint = base.analyticsAPIEndpoint;
            this.automationAPIEndpoint = base.automationAPIEndpoint;
            this.authenticationEndpoint = base.authenticationEndpoint;
            this.authenticationLoginRedirectUri = base.authenticationLoginRedirectUri;
            this.authenticationLogoutRedirectUri = base.authenticationLogoutRedirectUri;
            this.authenticationClientId = base.authenticationClientId;
            this.appInsightsInstrumentationKey = base.appInsightsInstrumentationKey;
            this.identityAPIEndpoint = base.identityAPIEndpoint;
        }
    }

    /**
     * Return a "raw" enpoint, without the '/api' bit that our (old) services need.
     */
    public get loaderEndpoint(): string {
        return this.loaderAPIEndpoint.substring(0, this.loaderAPIEndpoint.length - 4);
    }

    /**
     * Return a "raw" enpoint, without the '/api' bit that our (old) services need.
     */
    public get automationEndpoint(): string {
        return this.automationAPIEndpoint.substring(0, this.automationAPIEndpoint.length - 4);
    }

    /**
     * Return a "raw" enpoint, without the '/api' bit that our (old) services need.
     */
    public get identityEndpoint(): string {
        return this.identityAPIEndpoint.substring(0, this.identityAPIEndpoint.length - 4);
    }
}